import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import clsx from 'clsx';
// import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';

import { mappingItem } from 'lib/api/category';
import { getCategory } from 'lib/api/common';

import CurrentStatus from 'components/atoms/CurrentStatus';
import Modal from 'components/organisms/NewModal';
import Icon from 'components/atoms/Icon';

const useStyles = makeStyles((theme) => ({
  cateListWrap: {
    display: 'inline-flex',
    height: 300,
    margin: '10px 0',
    border: theme.palette.box.border,
    borderRadius: 4,
    fontSize: 14,
    '& span': {
      marginRight: 10,
      fontSize: 12,
      color: theme.palette.common.gray2,
    },
    '& .selected': { backgroundColor: theme.palette.common.selectedGreen },
    '& > .info': {
      width: 180,
      padding: '130px 0',
      margin: 0,
      textAlign: 'center',
    },
  },
  mainCateList: {
    minWidth: 150,
    overflow: 'auto',
    borderRight: theme.palette.box.border,
    cursor: 'pointer',
    '& > div': {
      padding: '14px 10px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.primary[50],
      },
    },
  },
  listWrap: {
    display: 'flex',
    overflow: 'hidden',
    cursor: 'pointer',
    '& > div': {
      overflow: 'auto',
      minWidth: 150,
      borderRight: theme.palette.box.border,
      '& > div': {
        padding: '14px 10px',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          backgroundColor: theme.palette.primary[50],
        },
      },
    },
  },
  middleCateList: {},
  smallCateList: {},
  subCateList: {},
}));

const Mapping = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const { categoryType, data, open, handleClose, type, confirmOnClick } = props;

  const [item, setItem] = useState('');
  const [loading, setLoading] = useState(true);
  const [cateStatus, setCateStatus] = useState(false);
  const [mainCategory, setMainCategory] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const initSelectedCode = {
    main: '',
    middle: '',
    small: '',
    sub: '',
  };
  const [selectedCode, setSelectedCode] = useState(initSelectedCode);
  const [selectedParams, setSelectedParams] = useState({});
  const [cateSeq, setCateSeq] = useState('');

  useEffect(() => {
    handlegetCategory();
  }, []);

  useEffect(() => {
    setItem('');
    setLoading(true);
  }, [data]);

  useEffect(() => {
    if (cateStatus === 'error') {
      setCategoryList([]);
      setSelectedCode(initSelectedCode);
    }
    //eslint-disable-next-line
  }, [cateStatus]);

  useEffect(() => {
    if (open) {
      let newCtgrSeq = 'oRow';
      if (type === 'oRow') {
        newCtgrSeq = data.CTGR_SEQ;
      } else if (type === 'sRow') {
        newCtgrSeq = data.sRow.CTGR_SEQ;
      } else if (type === 'tRow') {
        newCtgrSeq = data.sRow.tRow.CTGR_SEQ;
      }
      setCateSeq(newCtgrSeq);
      mappingItem({
        categoryCode: newCtgrSeq,
        categoryType: categoryType,
      })
        .then((response) => {
          const { data } = response.data;
          setItem(data);
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [open]);

  const handlegetCategory = (parameters) => {
    if (!parameters) {
      setCateStatus(true);
    }
    getCategory(!!parameters ? { userTpCode: parameters } : null)
      .then((response) => {
        const { data } = response.data;
        if (!!parameters) {
          setCategoryList(data);
        } else {
          setMainCategory(data);
        }
        setCateStatus(false);
      })
      .catch((error) => {
        setCategoryList([]);
        setCateStatus('error');
      });
  };

  const handleMainCate = (selectValue) => {
    setCateStatus(true);
    setSelectedCode({
      main: selectValue,
    });
    handlegetCategory(selectValue);
  };

  const handleSubCate = (type, value) => {
    let newSelectCode = { ...selectedCode };
    if (type === 'middle') {
      newSelectCode = {
        ...newSelectCode,
        sub: '',
        small: '',
      };
    } else if (type === 'small') {
      newSelectCode = {
        ...newSelectCode,
        sub: '',
      };
    }
    setSelectedCode({
      ...newSelectCode,
      [type]: value,
    });
    setSelectedParams({
      ctgrCode: cateSeq,
      ctgrType: categoryType,
      adverCtgrCode: value,
    });
  };

  const handleConfirm = (params) => {
    confirmOnClick(selectedParams);
    setSelectedCode(initSelectedCode);
    setCategoryList([]);
  };

  const handleModalClose = () => {
    handleClose();
    setSelectedCode(initSelectedCode);
    setCategoryList([]);
  };

  return (
    <>
      <Modal
        open={open}
        headerTitle={t('카테고리 맵핑')}
        handleClose={() => handleModalClose()}
        confirmBtnOpen
        confirmOnClick={() => handleConfirm(selectedParams)}
        style={{ minWidth: 300 }}
      >
        {loading ? (
          <CurrentStatus type="loading" />
        ) : (
          <>
            <div>
              {!!data && (
                <>
                  선택된 카테고리 : {data.CTGR_NM}
                  {!!data.sRow && (
                    <>
                      - {data.sRow.CTGR_NM}
                      {!!data.sRow.tRow && ' - ' + data.sRow.tRow.CTGR_NM}
                    </>
                  )}
                </>
              )}
            </div>
            <div className={classes.cateListWrap}>
              <div className={classes.mainCateList}>
                {(() => {
                  const result = [];
                  mainCategory.forEach((category, key) => {
                    const { ADVER_CNT, CODE_VAL, USER_TP_CODE } = category;
                    const selected = selectedCode.main === USER_TP_CODE;
                    result.push(
                      <div
                        key={key}
                        className={clsx({ selected })}
                        onClick={() =>
                          ADVER_CNT > 0
                            ? handleMainCate(USER_TP_CODE)
                            : setCateStatus('error')
                        }
                      >
                        {CODE_VAL} <span>({numeral(ADVER_CNT).format()})</span>
                        {selected && (
                          <Icon
                            icon={'faAngleRight'}
                            color={theme.palette.primary.deep}
                            className={classes.icon}
                            style={{ marginLeft: 'auto' }}
                          />
                        )}
                      </div>
                    );
                  });
                  return result;
                })()}
              </div>
              {cateStatus && cateStatus !== 'error' ? (
                <div style={{ width: 150 }}>
                  <CurrentStatus type="loading" />
                </div>
              ) : categoryList.length === 0 ? (
                <p className="info">
                  {cateStatus === false
                    ? t('카테고리를 선택해주세요.')
                    : cateStatus === 'error' && t('다시 선택해주세요.')}
                </p>
              ) : (
                <>
                  {(() => {
                    const result = [];
                    const middleResult = [];
                    const smallResult = [];
                    const subResult = [];
                    categoryList.forEach((category, key) => {
                      const { ADVER_CNT, CTGR_NM, CTGR_SEQ, SUB } = category;
                      const selected = selectedCode.middle === CTGR_SEQ;

                      middleResult.push(
                        <div
                          key={key}
                          className={clsx({ selected })}
                          onClick={() => handleSubCate('middle', CTGR_SEQ)}
                        >
                          {CTGR_NM}
                          <span>({numeral(ADVER_CNT).format()})</span>
                          {selected && ADVER_CNT > 0 && (
                            <Icon
                              icon={'faAngleRight'}
                              color={theme.palette.primary.deep}
                              className={classes.icon}
                              style={{ marginLeft: 'auto' }}
                            />
                          )}
                        </div>
                      );
                      if (!!selectedCode.middle) {
                        SUB.forEach((smallCategory, smallKey) => {
                          const {
                            HIRNK_CTGR_SEQ,
                            ADVER_CNT,
                            CTGR_NM,
                            CTGR_SEQ,
                          } = smallCategory;
                          const selected = selectedCode.small === CTGR_SEQ;
                          if (selectedCode.middle === HIRNK_CTGR_SEQ) {
                            smallResult.push(
                              <div
                                key={`${HIRNK_CTGR_SEQ}_${smallKey}`}
                                className={clsx({ selected })}
                                onClick={() => handleSubCate('small', CTGR_SEQ)}
                              >
                                {CTGR_NM}
                                <span>({numeral(ADVER_CNT).format()})</span>
                                {selected && ADVER_CNT > 0 && (
                                  <Icon
                                    icon={'faAngleRight'}
                                    color={theme.palette.primary.deep}
                                    className={classes.icon}
                                    style={{ marginLeft: 'auto' }}
                                  />
                                )}
                              </div>
                            );
                          }
                          if (!!selectedCode.small) {
                            smallCategory.SUB.forEach(
                              (subCategory, smallKey) => {
                                const {
                                  HIRNK_CTGR_SEQ,
                                  ADVER_CNT,
                                  CTGR_NM,
                                  CTGR_SEQ,
                                } = subCategory;
                                const selected = selectedCode.sub === CTGR_SEQ;
                                if (selectedCode.small === HIRNK_CTGR_SEQ) {
                                  subResult.push(
                                    <div
                                      key={`${HIRNK_CTGR_SEQ}_${smallKey}`}
                                      className={clsx({ selected })}
                                      onClick={() =>
                                        handleSubCate('sub', CTGR_SEQ)
                                      }
                                    >
                                      {CTGR_NM}
                                      <span>
                                        ({numeral(ADVER_CNT).format()})
                                      </span>
                                    </div>
                                  );
                                }
                              }
                            );
                          }
                        });
                      }
                    });
                    result.push(
                      <div key="categoryList" className={classes.listWrap}>
                        <div key="middle" className={classes.middleCateList}>
                          {middleResult}
                        </div>
                        {!!selectedCode.middle && smallResult.length > 0 && (
                          <div key="small" className={classes.smallCateList}>
                            {smallResult}
                          </div>
                        )}
                        {!!selectedCode.small && subResult.length > 0 && (
                          <div key="sub" className={classes.subCateList}>
                            {subResult}
                          </div>
                        )}
                      </div>
                    );
                    return result;
                  })()}
                </>
              )}
            </div>
            <div>
              {!!item && (
                <>
                  {item.CATE_NM}
                  {!!item.CATE_NM2 && ' - ' + item.CATE_NM2}
                  {!!item.CATE_NM2 && !!item.CATE_NM3 && ' - ' + item.CATE_NM3}
                </>
              )}
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default Mapping;
